"use client";

import { createAppKit } from "@reown/appkit/react";
import { EthersAdapter } from "@reown/appkit-adapter-ethers";
import {
  mainnet,
  sepolia,
  arbitrum,
  arbitrumSepolia,
  base,
  baseSepolia,
} from "@reown/appkit/networks";
import { WALLETCONNECT_PROJECT_ID } from "./appkit";

// Supported networks for devnet wallet linking
const networks = [mainnet, sepolia, arbitrum, arbitrumSepolia, base, baseSepolia] as const;

// Metadata for the wallet connection modal
const metadata = {
  name: "Spicenet Portal",
  description: "Link your wallet to Spicenet Devnet",
  url: typeof window !== "undefined" ? window.location.origin : "https://spicenet.io",
  icons: ["/favicon.ico"],
};

// Create the AppKit instance (singleton)
let appKitInstance: ReturnType<typeof createAppKit> | null = null;

export function getOrCreateAppKit() {
  if (typeof window === "undefined") return null;

  if (!appKitInstance) {
    appKitInstance = createAppKit({
      adapters: [new EthersAdapter()],
      networks: [...networks],
      metadata,
      projectId: WALLETCONNECT_PROJECT_ID,
      features: {
        analytics: false,
        email: false, // Disable email login since we use Privy for that
        socials: false, // Disable social logins
      },
      themeMode: "light",
      themeVariables: {
        "--w3m-accent": "#EA4B4B",
      },
    });
  }

  return appKitInstance;
}
